var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"is-user-avatar"},[_c('img',{attrs:{"src":_vm.newAvatar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }